var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSupport = function SvgSupport(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 30 30"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#B8EEFF",
    fillRule: "evenodd",
    d: "M15 28c7.18 0 13-5.82 13-13S22.18 2 15 2 2 7.82 2 15s5.82 13 13 13m0 2c8.284 0 15-6.716 15-15S23.284 0 15 0 0 6.716 0 15s6.716 15 15 15",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#B8EEFF",
    d: "M15.886 16.585c-.1.542-.554.953-1.105.953-.512 0-.962-.354-1.05-.859-.088-.493-.115-.816-.115-1.027 0-.733.248-1.131 1.053-1.739l1.26-.942c.993-.776 1.364-1.341 1.364-2.011 0-1.09-.847-1.781-2.086-1.781-1.202 0-2.08.545-2.483 1.493-.262.616-.774 1.167-1.443 1.167-.702 0-1.282-.586-1.118-1.268C10.688 8.393 12.448 7 15.331 7 18.223 7 20 8.487 20 10.938c0 1.383-.578 2.263-2.21 3.436l-1.2.88c-.39.286-.556.535-.704 1.331m-.977 2.712a1.351 1.351 0 1 1 0 2.703h-.21a1.351 1.351 0 0 1 0-2.703z"
  })));
};
export default SvgSupport;